"use client";
import { getCurrentPrice, pricingPlans } from "@/config/affiliate";
import { useState } from "react";

function IncomeByAffiliateProgramCalculator() {
  const basePrice: number = getCurrentPrice();

  const [noOfReferrals, setNoOfReferrals] = useState<number>(60);

  const totalEarnings: number = Math.floor(basePrice * noOfReferrals * pricingPlans.jobs.affiliateCommission);

  return (
    <div>
      <h3 className="mb-3 max-w-3xl text-center text-2xl">
        You could potentially earn{" "}
        <strong className="font-extrabold">
          $<span>{totalEarnings}</span>
        </strong>{" "}
        with <span>{noOfReferrals}</span> job posted through your referer links.
      </h3>
      <h4 className="my-3 mb-6 text-center">Use Calculator to check your potential Earning</h4>
      <div className="text-center">
        <input
          type="range"
          min={0}
          max={200}
          value={noOfReferrals}
          className="range range-accent"
          onChange={(e) => setNoOfReferrals(Number(e.target.value))}
        />
        <div className="mb-4 flex w-full justify-between px-2 text-xs">
          <span>0</span>
          <span>50</span>
          <span>100</span>
          <span>150</span>
          <span>200</span>
        </div>
      </div>

      <div className="my-8 text-center">
        <p>The calculation is based on each job posted through your referral link</p>
      </div>
    </div>
  );
}

export default IncomeByAffiliateProgramCalculator;
